import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private auth: AuthService, private router: Router) { 
    this.auth.isAuthenticated$.subscribe((loggedIn) => {
      if (loggedIn) {
        this.router.navigate(['/alerts']);
      }
    });
  }

  ngOnInit(): void { }

  login() {
    this.auth.loginWithRedirect();
  }
}
